module.exports = __webpack_public_path__ + "static/home-banner-04-4e0b98ed342b8b3ef0345a5556366fe3.jpg";